export const DEFAULT_VALUES = {
  nameClient: '',
  documentCpf: '',
  birthDate: '',
  phone: '',
  email: '',
  password: '',
  confirmPassword: '',
  isMktsrvTermsAccepted: false,
  isNewsletterOptIn: false
}
